import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import {Statement, StatementLineDto} from "../../dto/CardbroGateway/statement";
import {CardHolderDetails} from '../../dto/CardbroGateway/cardholder-details';
import {CardInfo} from '../../dto/CardbroGateway/card-info';

@Injectable({
  providedIn: 'root'
})
export class CardbroGatewayService {
  readonly apiPath = 'cb-gw/';
  public id: number;
  constructor(
    private http: HttpClient,
  ) { }

  getStatement(token: string): Observable<Statement> {
    return this.http.get(this.apiPath + 'get-statement/'+token) as Observable<Statement>;
  }

  getStatementEhi(token: string): Observable<Statement> {
    return this.http.get(this.apiPath + 'get-statement-ehi/'+token) as Observable<Statement>;
  }

  getStatement2Ehi(token: string): Observable<StatementLineDto[]> {
    return this.http.get(this.apiPath + 'get-statement2-ehi/'+token) as Observable<StatementLineDto[]>;
  }

  getCardholderDetails(token: string): Observable<CardHolderDetails> {
    return this.http.get(this.apiPath + 'get-cardholderdetails/'+token) as Observable<CardHolderDetails>;
  }

  getCardInfo(token: string): Observable<CardInfo> {
    return this.http.get(this.apiPath + 'get-cardinfo/'+token) as Observable<CardInfo>;
  }


}
